import styled from "styled-components";
import {Alert} from 'antd';

import 'antd/lib/alert/style';

export const AlertStyle = styled(Alert)`
	&.ant-alert-info {
		background-color: #ffffff !important;
		border: none !important;
		padding: 0;
	
		.ant-alert-icon {
			color: rgba(0, 0, 0, 0.65);;
			position: initial;
			padding-right: 5px;
		}
	}
`;